import DataStore from "../store";

/** Log user data to analytics at page load */
export function AnalyticsSetUserInfo() {
  if (typeof window.dataLayer === "undefined") {
    console.log("GTag plugin not enabled");
    return;
  }
  const userinfo = DataStore.state.user.userinfo;
  const currentAccount = DataStore.state.user.currentAccount;

  const siteStatus = undefined; // TODO: needs input from WP
  const isLoggedIn = !!userinfo;
  const isOTPLoggedIn = userinfo && !!userinfo.isOTP;
  const customerType = currentAccount && currentAccount.customerClass;
  const isAdmin = userinfo && !!userinfo.isAdmin;
  const isNetMetered = currentAccount && !!currentAccount.solarNetMeter;
  window.dataLayer.push({
    "event": "apiLoaded",
    siteStatus,
    isLoggedIn,
    isOTPLoggedIn,
    customerType,
    isAdmin,
    isNetMetered,
  });
}

/** Log the power status to analytics (later than apiLoaded) */
export function AnalyticsSetPowerStatus(powerStatus) {
  if (typeof window.dataLayer === "undefined") {
    console.log("GTag plugin not enabled");
    return;
  }
  window.dataLayer.push({
    "event": "powerLoaded",
    powerStatus,
  });
}
